import { keys as parentKeys } from '@copro/api';

const accounting = [...parentKeys.all, 'accounting'] as const;

export const keys = {
  accounting,

  space: (spaceId: string) => [...accounting, spaceId] as const,
  categories: (spaceId: string) => [...keys.space(spaceId), 'categories'] as const,
  expenses: (spaceId: string) => [...keys.space(spaceId), 'expenses'] as const,
  expensesByCategories: (spaceId: string, categoryIds: string[]) => [...keys.expenses(spaceId), categoryIds] as const,
};
